import { getComponentClasses } from '@99designs/common/utils/app';
import classNames from 'classnames';
import React from 'react';

interface Props {
    variations?: string[];
    href: string;
    onClick?: () => void;
    target?: string;
    noWrap?: boolean;
}

const Link: React.FunctionComponent<Props> = ({
    children,
    variations,
    onClick,
    noWrap,
    ...props
}) => {
    const classes = classNames(getComponentClasses('link', variations), {
        'link--nowrap': noWrap,
    });

    return (
        <a {...props} onClick={onClick} className={classes}>
            {children}
        </a>
    );
};

Link.defaultProps = {
    variations: [],
    noWrap: false,
};

export default Link;
